function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.3 11.706L11.706.3M.3.3l11.406 11.406",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 0.25,
  strokeLinejoin: "round",
  strokeMiterlimit: 10
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.006 12.006"
  }, props), _ref);
}

export default SvgClose;